// Site Configuration - Easy to customize
// Change these values to customize your bus company website

export const siteConfig = {
  // Booking Configuration
  carrierCode: "MZ",  // Carrier code for database queries (e.g., "MZ" for Mzansi Express, "BY" for Brooklyn Express)
  
  // Company Information
  companyName: "CityLink",
  tagline: "Connecting Africa",
  description: "Seamless cross-border travel between Johannesburg and Maputo with premium comfort and reliability",
  
  // Contact Information
  phone: ["+27 63 832 6914"],
  email: "info@citylinkcoaches.com",
  workingHours: "Monday - Sunday: 6:00 AM - 10:00 PM",
  
  // Office Locations
  locations: [
    {
      id: 1,
      name: "Johannesburg (Bez Valley)",
      address: "1105 Albertina Sisulu Rd\nBez Valley",
      type: "head-office",
      phone: "+27 63 832 6914",
      email: "Info.jhb@citylink.co.mz",
      lat: -26.1886821,
      lng: 28.0919102,
      mapUrl: "https://www.google.com/maps/search/?api=1&query=1105%20Albertina%20Sisulu%20Rd%2C%20Bez%20Valley%2C%20Johannesburg"
    },
    {
      id: 2,
      name: "Maputo",
      address: "Rua João Mulungu Nr 451/A\nHospital José Macamo, Maputo",
      type: "branch",
      phone: "+258 84 606 8783",
      email: "Info@Citylink.co.mz",
      lat: -25.968430,
      lng: 32.563181,
      mapUrl: "https://www.google.com/maps/search/?api=1&query=Rua%20Jo%C3%A3o%20Mulungu%2C%20Maputo"
    },
    {
      id: 3,
      name: "Kempton Park",
      address: "6 Monument Rd\nKempton Park CBD",
      type: "branch",
      phone: "+27 78 774 5028",
      email: "Info.jhb@citylink.co.mz",
      lat: -26.1002,
      lng: 28.2370,
      mapUrl: "https://www.google.com/maps/search/?api=1&query=6%20Monument%20Rd%2C%20Kempton%20Park%20CBD"
    },
    {
      id: 4,
      name: "Matola (Hanhane)",
      address: "Matola – Hanhane\nPraceta Herculano Nr 47",
      type: "branch",
      phone: "+258 87 318 3333",
      email: "Info@Citylink.co.mz",
      lat: -25.953759,
      lng: 32.460389,
      mapUrl: "https://www.google.com/maps/search/?api=1&query=Praceta%20Herculano%2C%20Matola"
    },
    {
      id: 5,
      name: "Johannesburg (CBD)",
      address: "95 Kerk Street\nJHB CBD",
      type: "branch",
      phone: "+27 60 383 0069",
      email: "Info.jhb@citylink.co.mz",
      lat: -26.2041,
      lng: 28.0473,
      mapUrl: "https://www.google.com/maps/search/?api=1&query=95%20Kerk%20Street%2C%20Johannesburg"
    }
  ],
  
  // Additional Bus Images Configuration
  additionalBusImages: {
    enabled: true,
    images: [
      // Example images - add your bus images here
      {
        id: 1,
        path: "/assets/Additional-Images/Additional1.jpeg",
        alt: "Modern Bus Fleet", //Description of the image
        category: "interior", //can be 'interior' or 'fleet'or 'featured'
        featured: true
      },
      {
        id: 2,
        path: "/assets/Additional-Images/Additional2.jpeg",
        alt: "Ride in Comfort",
        category: "fleet"
      },
      {
        id: 3,
        path: "/assets/Additional-Images/Additional3.jpeg",
        alt: "Luxury Coach Fleet",
        category: "fleet"
      },
      {
        id: 4,
        path: "/assets/Additional-Images/Additional4.jpeg",
        alt: "Luxury Coach Fleet",
        category: "fleet"
      },
      {
        id: 5,
        path: "/assets/Additional-Images/Additional6.jpeg",
        alt: "Luxury Coach Fleet",
        category: "interior"
      },
      {
        id: 6,
        path: "/assets/Additional-Images/Additional7.jpeg",
        alt: "Premium Coach Interior",
        category: "fleet"
      },
      {
        id: 7,
        path: "/assets/Additional-Images/Additional8.jpeg",
        alt: "Comfortable Seating",
        category: "fleet"
      },
      {
        id: 8,
        path: "/assets/Additional-Images/Additional9.jpeg",
        alt: "Modern Fleet",
        category: "fleet"
      }
    ]
  },
  
  // Social Media (leave empty string to hide)
  social: {
    facebook: "https://www.facebook.com/citylinkcoaches/",
    twitter: "",
    instagram: "https://www.instagram.com/citylinkcoaches/",
    linkedin: "",
    tiktok: "https://www.tiktok.com/@citylinkcoaches",
  },
  
  // App Configuration
  hasApp: false,
  appName: "CityLink App",
  appStoreUrl: "", 
  hasLuggageTracking: false,
  luggageServicesEnabled: false, // Set to true to show luggage services section
  
  // WhatsApp Chatbot Configuration
  whatsappChatbot: {
    enabled: false, // Master toggle - set to true to enable WhatsApp chatbot
    whatsappUrl: "https://wa.me/27833255246?text=Hello%20I%27d%20like%20to%20book%20a%20bus%20ticket", // WhatsApp chatbot link with proper international format and encoded message
    botName: "CityLink Assistant",
    cardTitle: "Book with Our WhatsApp Bot",
    cardDescription: "Get instant help with bookings through our intelligent chatbot available 24/7 on WhatsApp.",
    buttonText: "Start Chat",
    floatingIconText: "Chat with us on WhatsApp"
  },
  
  // Booking Configuration
  bookingUrl: "https://www.travelticket.co.za/CityLinkOnline/",
  bookingEnabled: true, // Set to false to disable booking and show "Booking Coming Soon"
  
  // On-Site Booking Configuration (in-app booking form)
  onSiteBookingEnabled: false, // Set to true to show the in-app booking form, false to hide entire booking section
  
  // E-Commerce Booking Configuration (external booking link)
  ecomBookingEnabled: true, // Set to true to show a "Book Now" button linking to external booking system
  ecomBookingUrl: "https://www.travelticket.co.za/CityLinkOnline/", // URL for "Book Now" button when ecomBookingEnabled is true
  
  // About Section
  about: {
    title: "Premium Cross-Border Travel Experience",
    description: `At CityLink, we specialize in connecting <strong>South Africa and Mozambique</strong> with <strong>exceptional bus service</strong>. With years of expertise in <strong>cross-border logistics</strong>, we've perfected the art of <strong>seamless, comfortable long-distance travel</strong>. Our modern fleet of <strong>luxury coaches</strong> is engineered for <strong>passenger comfort</strong> on extended journeys, featuring spacious seating, climate control, and professional amenities. We pride ourselves on <strong>reliability, safety, and punctuality</strong>. Every trip is planned with <strong>precision</strong> to ensure you arrive refreshed and on time. Whether you're traveling for business or leisure between Johannesburg and Maputo, CityLink delivers the journey you deserve.`,
  },
  
  // Why Choose Us
  whyChooseUs: [
    "<strong class='font-semibold dark:text-secondary-foreground text-foreground'>Unbeatable value</strong> - Save money without sacrificing luxury",
    "<strong class='font-semibold dark:text-secondary-foreground text-foreground'>Trusted heritage</strong> - Over a decade of safe cross-border journeys",
    "<strong class='font-semibold dark:text-secondary-foreground text-foreground'>Premium comfort zones</strong> - Spacious seating, climate control, USB charging",
    "<strong class='font-semibold dark:text-secondary-foreground text-foreground'>24/7 travel support</strong> - Real-time updates and 24-hour customer service",
    "Professional and courteous staff",
    "Strategic pickup and drop-off locations",
  ],
  
  // Bus Routes / Services (main services the company provides)
  routes: [
    {
      id: 1,
      from: "Johannesburg",
      to: "Maputo",
      departure: "18:00 - 21:00",
      arrival: "05:00 - 06:30",
      pickupPoints: [
        {
          name: "Pickup 1",
          address: "95 Kerk Street, JHB CBD",
          landmark: "Next to Grande Hotel",
          lat: -26.2041,
          lng: 28.0473,
          checkIn: "18:00",
          departure: "20:00"
        },
        {
          name: "Pickup 2",
          address: "1105 Albertina Sisulu Road, Bez Valley, JHB",
          landmark: "",
          lat: -26.1887,
          lng: 28.0919,
          checkIn: "19:00",
          departure: "21:00"
        }
      ],
      dropoffPoints: [
        {
          name: "Stop 1",
          address: "N4 Tchumene, Matola, Mozambique",
          landmark: "",
          lat: -25.900349,
          lng: 32.433741,
          arrival: "05:00"
        },
        {
          name: "Stop 2",
          address: "Preceta Herculano, Bairro Hanhane, Matola",
          landmark: "",
          lat: -25.953759,
          lng: 32.460389,
          arrival: "05:30"
        },
        {
          name: "Final Stop",
          address: "Rua João Mulungu 451, Maputo",
          landmark: "Next to Jose Macamo Hospital",
          lat: -25.968430,
          lng: 32.563181,
          arrival: "06:30"
        }
      ],
      stops: ["Johannesburg", "Matola", "Maputo"]
    },
    {
      id: 2,
      from: "Maputo",
      to: "Johannesburg",
      departure: "17:30 - 19:45",
      arrival: "04:30 - 05:30",
      pickupPoints: [
        {
          name: "Pickup 1",
          address: "Rua João Mulungu 451, Maputo",
          landmark: "Next to Jose Macamo Hospital",
          lat: -25.968430,
          lng: 32.563181,
          checkIn: "17:30",
          departure: "18:30"
        },
        {
          name: "Pickup 2",
          address: "Preceta Herculane, Bairro Hanhane, Matola",
          landmark: "",
          lat: -25.953759,
          lng: 32.460389,
          checkIn: "18:45",
          departure: "19:45"
        }
      ],
      dropoffPoints: [
        {
          name: "Stop 1",
          address: "Sasol Garage, Corner Prairie Street and Diagonal Street, Rosettenville",
          landmark: "",
          lat: -26.2434592,
          lng: 28.0563751,
          arrival: "04:30"
        },
        {
          name: "Stop 2",
          address: "95 Kerk Street, JHB CBD",
          landmark: "Next to Grande Hotel",
          lat: -26.2041,
          lng: 28.0473,
          arrival: "05:00"
        },
        {
          name: "Final Stop",
          address: "1105 Albertina Sisulu Road, Bez Valley, JHB",
          landmark: "",
          lat: -26.1887,
          lng: 28.0919,
          arrival: "05:30"
        }
      ],
      stops: ["Maputo", "Matola", "Johannesburg"]
    }
  ],
  
  // Luggage Services
  luggageServices: [
    {
      id: 3,
      title: "Travel with Luggage",
      description: "Professional luggage transportation service",
      features: [
        "Luggage weighing",
        "Charge per kilogram",
        "Fixed charge items"
      ]
    },
    {
      id: 4,
      title: "Send Luggage",
      description: "Secure luggage storage and transport",
      features: [
        "Charge per kilogram",
        "Fixed charge items"
      ]
    },
  ],
  
  // Booking Partners
  bookingPartners: [
    "Partner outlets across major terminals",
    "Online booking through our website",
  ],
  
  // Third Party Partners
  thirdPartyPartners: [
    {
      id: 1,
      name: "Computicket",
      image: "TP1.png",
      url: "https://computicket.com/travel/bus/booking"
    },
    {
      id: 2,
      name: "QuickBus",
      image: "TP2.png",
      url: "https://southafrica.quickbus.com/home"
    },
    {
      id: 3,
      name: "TravelTicket",
      image: "TP3.png",
      url: "https://www.travelticket.co.za/travelticketonline/"
    },
    {
      id: 4,
      name: "Busbud",
      image: "TP4.png",
      url: "https://www.busbud.com/"
    },
    {
      id: 5,
      name: "JustGo",
      image: "TP5.png",
      url: "https://www.justgo.co.za/"
    },
    {
      id: 6,
      name: "FlightSite",
      image: "TP6.png",
      url: "https://www.flightsite.co.za/"
    }
  ],
  
  // Features / What We Offer (bus amenities/features)
  features: [
    {
      title: "Long Distance Travel",
      description: "Comfortable Cross Border journeys with multiple stops",
      icon: "Route",
      path: "/long-distance-travel",
    },
    {
      title: "Online Booking",
      description: "Easy booking via website or partner outlets",
      icon: "Smartphone",
      path: "https://www.travelticket.co.za/CityLinkOnline/",
    },
    {
      title: "Luggage Services",
      description: "Professional luggage transport and unattended luggage services",
      icon: "Package",
      path: "/luggage-services",
    },
    {
      title: "Bus Hire",
      description: "Special Hire services for events and group travel",
      icon: "bus",
      path: "/bus-hire",
    }
  ],

  // Bus Amenities
  amenities: [
    "Air Conditioning",
    "Reclining Seats", 
    "Ample Legroom",
    "USB Charging",
    "Entertainment System",
    "Free WiFi Onboard",
    "Complimentary Snacks",
    "Restrooms Onboard",
  ],

  // Stats displayed on hero
  //stats: [
  //  { value: "1", label: "Year Experience" },
  //  { value: "2", label: "Routes" },
  //  { value: "1000+", label: "Happy Travelers" },
  //],

    stats: [
    { value: "Multiple", label: "Daily Services" },
    { value: "Expert", label: "Drivers" },
    { value: "99%", label: "On-Time Record" },
  ],

} as const;

export type SiteConfig = typeof siteConfig;
